import {PurchaseOrderData} from "@/types";
import {PurchaseOrderState} from "@/types/store/adminzone";

export const state: PurchaseOrderState = {
  purchaseOrderNumbers: [] as Array<PurchaseOrderData>,
  purchaseOrderNumbersTotalCount: null
}
